<template>
  <div class="indeCenJ">
    <h2>双项服务</h2>
    <div>
      <img src="../assets/img/jie.png" alt="解决方案">
    </div>
    <p class="beianPtips"><span @click="goBeian">陕ICP备15007224号</span></p>
  </div>
</template>

<script>
  export default {
  	name: 'indexCenterJ',
  	data () {
  		return {

  		}
  	},
    mounted:function(){

    },
  	methods:{
      goBeian(){
        window.location.href = 'http://www.beian.miit.gov.cn';
      },
  	}
  }
</script>

<style scoped lang="scss">
  .indeCenJ{
    display: flex;
    flex-direction: column;
    align-items: center;
    .beianPtips{
      position: absolute;
      left: 0;
      bottom: 2rem;
      width: 100%;
      color: #3a3a3a;
      text-align: center;
      span:hover{
        color: #000;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    h2{
      margin: 6rem 0 1rem -4rem;;
      font-weight: 100;
    }
    div{
      width: 100%;
      background: url(../assets/img/jie-bg.png) no-repeat;
      background-size: 100% auto;
      background-position: center 80%;
      img{
        width: 70%;
        margin: 0 auto;
      }
    }
    @media screen and (max-width: 1400px) {
      div{
        background-position: center 83%;
        img{
          width: 90%;
        }
      }
    }
    @media screen and (max-width: 600px) {
      div{
        img{
          width: 100%;
        }
      }
      h2{
        font-size: 1rem;
        margin:  2rem 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexCenterJ.vue